import useRequest, {
    RequestFn, RequestKeys,
} from 'app/hooks/useRequest'

import requestConfig from 'app/requests/Opportunity/Opportunity.requests'

const useGetOpportunityById = (id: number) => {
    return useRequest({
        key: RequestKeys.getOpportunityById,
        params: {
            id,
        },
        requestFunc: RequestFn.getEntity(requestConfig.GetOpportunityById),
        enabled: Boolean(id),
        keepPreviousData: true,
    })
}

export default useGetOpportunityById
